import { render } from "./HubEventDetailView.vue?vue&type=template&id=774453f7&ts=true"
import script from "./HubEventDetailView.vue?vue&type=script&lang=ts"
export * from "./HubEventDetailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__